import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { dripiconlist } from "src/helpers/iconList";
import { useAppSelector } from "src/store";
import { getSectors } from "src/store/system/saga";
import { SectorDto } from "src/store/system/type";
import { createSpesificationSaga } from "src/store/web-spesifications/saga";
import * as Yup from "yup";

const SpesificationsCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);
  const [sectors, setSectors] = useState<SectorDto[]>([]);
  useEffect(() => {
    open &&
      dispatch(
        getSectors({
          payload: {
            onSuccess: (m, p) => setSectors(p),
            onError: () => {},
          },
        })
      );
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Spesifications.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Description: "",
          Title: "",
          VideoLink: "",
          Icon: "",
          SectorId: "",
          ImageFile: "",
          Images: [],
          SeoTitle: "",
          SeoDescription: "",
          SeoImageFile: "",
          Name: "",
          ShowWeb: true,
          Translates: languages.map((x) => {
            return {
              LanguageId: x.EnumId,
              Title: "",
              Description: "",
              Name: "",
              SeoTitle: "",
              SeoDescription: "",
            };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            createSpesificationSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Title: Yup.string().required(t("Validation.Required").toString()),
          Name: Yup.string().required(t("Validation.Required").toString()),
          Description: Yup.string().required(
            t("Validation.Required").toString()
          ),
          Icon: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Name: Yup.string().required(t("Validation.Required").toString()),
              Title: Yup.string().required(t("Validation.Required").toString()),
              Description: Yup.string().required(
                t("Validation.Required").toString()
              ),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("Spesifications.Name").toString(),
          },
          {
            field: "Title",
            label: t("Spesifications.Title").toString(),
            type: "textarea",
          },
          {
            field: "Description",
            label: t("Spesifications.Description").toString(),
            isEditor: true,
          },
          {
            field: "SeoTitle",
            label: t("Spesifications.SeoTitle").toString(),
            type: "textarea",
          },
          {
            field: "SeoDescription",
            label: t("Spesifications.SeoDescription").toString(),
            type: "textarea",
          },
        ]}
        inputs={[
          {
            field: "SectorId",
            placement: "top",
            label: t("Spesifications.Sector").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "Id",
              options: sectors,
            },
          },
          {
            field: "Icon",
            placement: "top",
            label: t("Spesifications.Icon").toString(),
            type: "select",
            lookup: {
              renderValue: (e) => <i className={e} />,
              labelKey: "Id",
              valueKey: "Id",
              options: dripiconlist.map((x, i) => {
                return {
                  Id: x,
                  Name: x,
                };
              }),
            },
          },

          {
            field: "ImageFile",
            label: t("Spesifications.ImageFile").toString(),
            type: "file",
            accept: "image/png, image/jpeg",
          },
          {
            field: "SeoImageFile",
            label: t("Spesifications.SeoImageFile").toString(),
            type: "file",
          },
          {
            field: "Images",
            label: t("Spesifications.SliderImages").toString(),
            type: "file",
            multiple: true,
          },

          {
            field: "ShowWeb",
            label: t("Spesifications.ShowWeb").toString(),
            type: "switch",
          },
        ]}
      />
    </React.Fragment>
  );
};
export default SpesificationsCreateForm;
